import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";

const ContactUs = () => {
  const branches = [
    {
      name: "Sidwell Branch",
      address: "81 B Haupt Street, Sidwell, Port Elizabeth, South Africa, 6061",
      mapLink:
        "https://www.google.com/maps/dir/?api=1&destination=81+B+Haupt+Street,+Sidwell,+Port+Elizabeth,+South+Africa",
    },
    {
      name: "Kempston Branch",
      address: "304 Kempston Road, Port Elizabeth, South Africa, 6061",
      mapLink:
        "https://www.google.com/maps/dir/?api=1&destination=304+Kempston+Road,+Port+Elizabeth,+South+Africa",
    },
  ];

  return (
    <div
      className="min-h-screen bg-cover bg-center text-black flex flex-col items-center py-10 px-4"
      style={{ backgroundImage: "url('/bg.jpg')" }}
    >
      <h1 className="text-4xl font-bold text-black rounded-lg p-8 bg-white bg-opacity-80 mb-8">
        Contact Us
      </h1>

      <div className="w-full max-w-3xl bg-white bg-opacity-80 rounded-lg p-8 shadow-lg space-y-10">
        {/* Contact Information */}
        <div className="text-center space-y-4">
          <h2 className="text-2xl font-semibold text-burgundy-600">
            Contact Information
          </h2>
          <div className="flex items-center justify-center space-x-4">
            <a
              href="tel:0410230241"
              className="flex items-center space-x-2 text-lg hover:text-burgundy-600 transform transition-transform duration-300 hover:scale-110"
            >
              <FontAwesomeIcon icon={faPhone} className="text-xl" />
              <span>041 023 0241</span>
            </a>
          </div>
          <div className="flex items-center justify-center space-x-4">
            <a
              href="mailto:info@autoimperium.co.za"
              className="flex items-center space-x-2 text-lg hover:text-burgundy-600 transform transition-transform duration-300 hover:scale-110"
            >
              <FontAwesomeIcon icon={faEnvelope} className="text-xl" />
              <span>info@autoimperium.co.za</span>
            </a>
          </div>
        </div>

        {/* Social Media */}
        <div className="text-center space-y-4">
          <h2 className="text-2xl font-semibold text-burgundy-600">
            Follow Us
          </h2>
          <div className="flex items-center justify-center space-x-6">
            <a
              href="https://www.facebook.com/imperiumautope"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-lg hover:text-burgundy-600 transform transition-transform duration-300 hover:scale-110"
            >
              <FontAwesomeIcon icon={faFacebook} className="text-2xl" />
              <span>Facebook</span>
            </a>
            <a
              href="https://www.instagram.com/imperiumautogroupza/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-lg hover:text-burgundy-600 transform transition-transform duration-300 hover:scale-110"
            >
              <FontAwesomeIcon icon={faInstagram} className="text-2xl" />
              <span>Instagram</span>
            </a>
            <a
              href="https://www.tiktok.com/@imperium_auto_spares"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-lg hover:text-burgundy-600 transform transition-transform duration-300 hover:scale-110"
            >
              <FontAwesomeIcon icon={faTiktok} className="text-2xl" />
              <span>TikTok</span>
            </a>
          </div>
        </div>

        {/* Branches */}
        <div>
          <h2 className="text-2xl font-semibold text-burgundy-600 text-center mb-6">
            Visit Our Branches
          </h2>
          <div className="space-y-5 hover:cursor-pointer">
            {branches.map((branch, index) => (
              <div
                key={index}
                className="bg-gray-50 border-l-4 border-burgundy-600 rounded-lg p-5 hover:bg-gray-200 transition duration-300"
              >
                <h3 className="text-xl font-medium text-black">
                  {branch.name}
                </h3>
                <a
                  href={branch.mapLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg text-gray-700 hover:text-burgundy-600 transition duration-300"
                >
                  {branch.address}
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Trading Hours */}
        <div className="text-center space-y-2">
          <h2 className="text-2xl font-semibold text-burgundy-600">
            Trading Hours
          </h2>
          <p className="text-lg">Mon - Fri: 7h30am - 5pm</p>
          <p className="text-lg">Sat - Holidays: 7h30am - 1pm</p>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
